import mitt, { Emitter } from 'mitt';
import to from 'await-to-js';
import { getApi } from './init';
import { getAuthManager } from './auth-manager';

export enum ORG_MANAGER_EVENT {
  GET_ORG = 'get:org',
}

interface IOrg {
  admin: number;
  code: string;
  createBy: string;
  createTime: Record<string, unknown>;
  fullName: string;
  id: string;
  logo: string;
  modifyBy: string;
  modifyTime: Record<string, unknown>;
  remark: string;
  shortName: string;
  status: string;
  type: string;
}

type IEventBody = Record<ORG_MANAGER_EVENT, IOrg | null>;

class OrgManager {
  org: IOrg | null = null;

  // 事件总线
  private _eventBus: Emitter<IEventBody> = mitt();
  private _fetching = false;

  private _emit<K extends ORG_MANAGER_EVENT>(type: K, data: IEventBody[K]) {
    this._eventBus.emit(type, data);
  }

  on<K extends ORG_MANAGER_EVENT>(type: K, handler: (data: IEventBody[K]) => void) {
    const fn = (args: any) => {
      handler(args);
    };
    this._eventBus.on(type, fn);
  }

  once<K extends ORG_MANAGER_EVENT>(type: K, handler: (data: IEventBody[K]) => void) {
    const fn = (args: any) => {
      this._eventBus.off(type, fn);
      handler(args);
    };
    this._eventBus.on(type, fn);
  }

  async getOrg<T>(refetch = false, getOrgApi: () => Promise<T>) {
    return new Promise(async (resolve) => {
      function handle(org: IOrg | null) {
        resolve(org);
      }

      if (this.org && !refetch) {
        resolve(this.org);
      } else {
        this.once(ORG_MANAGER_EVENT.GET_ORG, handle);
        if (!this._fetching) {
          this._fetching = true;
          const authManager = getAuthManager();
          const accessToken = await authManager.getAccessToken();
          if (!accessToken) {
            this._emit(ORG_MANAGER_EVENT.GET_ORG, null);
            return;
          }
          const { aiadEmsApi } = getApi();
          const [err, res] = await to(getOrgApi ? getOrgApi() : aiadEmsApi.getOrgCurrent());

          if (err) {
            this._emit(ORG_MANAGER_EVENT.GET_ORG, null);
          } else {
            this.org = res as IOrg;
            this._emit(ORG_MANAGER_EVENT.GET_ORG, res as IOrg);
          }
          this._fetching = false;
        }
      }
    });
  }
}

let orgManager;
export function getOrgManager() {
  if (!orgManager) {
    orgManager = new OrgManager();
  }
  return orgManager;
}
